/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable max-len */
/* eslint-disable react/jsx-closing-bracket-location */
import * as moment from 'moment';
import React, { Component } from 'react';
import Swal from 'sweetalert2';
import {
	CommaSeparator,
	GetFormat,
	GetUtcDate,
	checkIfLender,
	convertToLangKey,
	getTotalInterestPaid
} from '../../AppUtil/AppUtil';

import { Divider } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import { withTranslation } from 'react-i18next';
import LoanService from '../../Service/LoanService';
import {
	toastWhenPaymentMethodBank,
	toastWhenPaymentMethodCash,
	toastWhenPaymentMethodCashPastDate
} from '../../SweetAlertUtil/util';
import DwollaPlaid from '../Common/DwollaPlaid';
import Loader from '../Common/Loader';
import ButtonColumns from '../Common/LoanViewComponent/ButtonColumns';
import Buttons from '../Common/LoanViewComponent/Buttons';
import BaseField from '../Common/Loans/Base';
import PaymentMethod from '../Common/PaymentMethod';
import PageHeaderTitle from '../Common/Profile/PageHeaderTitle';

const API_URLS = window.AppConfig.API_URLS;
const LOAN_MODIFICATION_ACTION = window.AppConfig.LOAN_MODIFICATION_ACTION;
const LOAN_TYPES = window.AppConfig.LOAN_TYPES;

class ViewModification extends Component {
	constructor(props) {
		super(props);
		this.state = {
			_isLoading: false,
			_modifiedLoan: {},
			_isDwollaPlaidScreenOpen: false,
			_headingName: '',
			_isPaymentMethodScreenOpen: false
		};
	}

	openPaymentScreen = () => {
		this.setState({
			_isPaymentMethodScreenOpen: true
		});
	};

	closePaymentScreen = () => {
		this.setState({
			_isPaymentMethodScreenOpen: false
		});
	};

	checkTheModifiedLoanObject = (newData, oldData) => {
		return oldData !== newData;
	};

	setDefaultName = () => {
		if (checkIfLender(this.props.currentUserId, this.props.loan)) {
			this.setState({
				_headingName: 'label.borrower'
			});
		} else {
			this.setState({
				_headingName: 'label.lender'
			});
		}
	};

	redirectToDwollaPlaid = () => {
		this.setState({
			_isDwollaPlaidScreenOpen: true
		});
	};

	closeDwollaPlaid = () => {
		this.setState({
			_isDwollaPlaidScreenOpen: false
		});
		this.handleAcceptModificationRequest();
	};

	onBackDwollaPlaid = () => {
		this.setState({
			_isDwollaPlaidScreenOpen: false
		});
	};

	startLoader = () => {
		this.setState({
			_isLoading: true
		});
	};

	stopLoader = () => {
		this.setState({
			_isLoading: false
		});
	};

	toastErrorNoConfirmation = errorMsg => {
		Swal.fire({
			imageUrl: 'https://cdn-icons-png.flaticon.com/512/5219/5219070.png',
			title: this.props.t('sweetalert_title.error'),
			text: errorMsg,
			allowOutsideClick: false,
			// icon: 'error',
			customClass: 'otp_message_success',
			imageAlt: 'Custom Image'
		});
	};

	toastOnSuccess = () => {
		Swal.fire({
			animation: false,
			allowOutsideClick: false,
			title: this.props.t('sweetalert_title.thank_you'),
			text: this.props.t('app_message.your_loan_terms_have_been_updated'),
			icon: 'success',
			customClass: 'otp_message_success'
		});
	};

	toastOnPastPaymentDate = () => {
		Swal.fire({
			animation: false,
			allowOutsideClick: false,
			title: this.props.t('sweetalert_title.request_submitted'),
			text: this.props.t('app_message.loan_modified_lender', { borrower_name: this.props.modifiedObject.name }),
			icon: 'success',
			confirmButtonText: this.props.t('buttons.continue_upc'),
			customClass: 'otp_message_success'
		});
	};

	toastOnPastPaymentDateReminder = () => {
		return Swal.fire({
			animation: false,
			allowOutsideClick: false,
			title: this.props.t('sweetalert_title.accept_reminder'),
			text: this.props.t('app_message.accept_reminder_message'),
			icon: 'info',
			showCancelButton: true,
			confirmButtonText: this.props.t('buttons.continue_upc'),
			customClass: 'otp_message_success'
		}).then(res => {
			if (res.value) return true;
		});
	};

	handleAcceptModificationRequest = () => {
		const loanObj = this.props.loan;
		const walletDetails = this.props.currentUser.profile.wallet_connected || false;
		if (!walletDetails) {
			this.redirectToDwollaPlaid();
			return false;
		} else if (!loanObj.disbursal_mode && (loanObj.loan_workflow_id === 1 || loanObj.loan_workflow_id === 0)) {
			if (
				(loanObj.created_by === this.props.currentUserId && loanObj.loan_type === LOAN_TYPES.LEND) ||
				(loanObj.created_by !== this.props.currentUserId && loanObj.loan_type === LOAN_TYPES.BORROW)
			) {
				this.openPaymentScreen();
				return false;
			}
		}
		this.acceptModification();
	};

	handlePaymentMethodCallback = async payment => {
		if (payment) {
			if (payment.payment_mode === 'ACH') {
				toastWhenPaymentMethodBank(
					this.props.modifiedObject.name,
					payment,
					this.acceptModification,
					this.closePaymentScreen
				);
			} else {
				if (moment(payment.payment_date).diff(moment(), 'day') < 0) {
					toastWhenPaymentMethodCashPastDate(payment, this.acceptModification, this.closePaymentScreen);
				} else {
					toastWhenPaymentMethodCash(
						this.props.modifiedObject.name,
						payment,
						this.acceptModification,
						this.closePaymentScreen
					);
				}
			}
		}
	};

	acceptModification = async payment => {
		try {
			this.startLoader();
			const requestBody = {
				action: LOAN_MODIFICATION_ACTION.ACCEPT
			};
			if (payment) {
				requestBody.payment_mode = payment.payment_mode;
				if (payment.payment_mode === 'OFFLINE') {
					requestBody.payment_date = payment.payment_date;
				} else {
					requestBody.payment_date = new Date().toISOString();
				}
			} else {
				requestBody.payment_date = new Date().toISOString();
			}

			let dateToCheck = moment(this.state._modifiedLoan.first_installment_date).utc();

			let currentDate = moment().utc();

			dateToCheck = dateToCheck.startOf('day');
			currentDate = currentDate.startOf('day');

			if (dateToCheck.isBefore(currentDate)) {
				const result = await this.toastOnPastPaymentDateReminder();
				console.log(result, 'result');

				if (result) {
					console.log('User clicked Continue'); // dont remove
				} else {
					this.stopLoader();
					 //
					return; // Exit if the user didn't confirm
				}
			}

			const response = await LoanService.create(
				`loan/${this.props.modifiedObject.id}/modification-action`,
				requestBody
			);

			if (!response.status) {
				this.toastErrorNoConfirmation(response.data);
			} else {
				if (payment && moment(payment.payment_date).diff(moment(), 'day') < 0) {
					this.toastOnPastPaymentDate();
				} else {
					this.toastOnSuccess();
				}
			}
			this.props.closeSeeModification();
			this.stopLoader();
		} catch (err) {
			console.log(err);
			this.stopLoader();
		}
	};

	rejectModification = async () => {
		try {
			this.startLoader();
			const requestBody = {
				action: LOAN_MODIFICATION_ACTION.REJECT
			};
			await LoanService.create(`loan/${this.props.modifiedObject.id}/modification-action`, requestBody);
			this.props.closeSeeModification();
			this.stopLoader();
		} catch (err) {
			console.log(err);
			this.stopLoader();
		}
	};

	calculateEmi = async () => {
		this.startLoader();
		const loanForm = this.props.loanObject;
		const requestBody = {
			principal: parseFloat(loanForm.principal),
			first_installment_date: loanForm.first_installment_date,
			start_date: loanForm.disbursal_date || loanForm.start_date || GetUtcDate(new Date()),
			annual_rate: parseFloat(loanForm.annual_rate),
			frequency: loanForm.frequency,
			no_of_installments: parseInt(loanForm.no_of_installments),
			loan_type: this.props.modifiedObject.loan_type,
			lender_state: loanForm.lender_state
		};
		if (loanForm.disbursal_date) {
			requestBody.disbursal_date = GetUtcDate(loanForm.disbursal_date);
		}
		try {
			const response = await LoanService.create(API_URLS.GET_EMI_AMOUNT, requestBody);

			response.data.amount_payable_per_installment = response.data.installments[0].emi_amount;
			this.props.modifiedObject.amount_payable_per_installment =
				this.props.modifiedObject.installments[0].emi_amount;

			response.data.total_interest = getTotalInterestPaid(response.data);
			this.props.modifiedObject.total_interest = getTotalInterestPaid(this.props.modifiedObject);

			this.props.setModifiedData(response.data);
			this.setState({
				_modifiedLoan: response.data
			});
			this.stopLoader();
		} catch (error) {
			console.log(error);
			this.stopLoader();
			return null;
		}
	};

	componentDidMount() {
		this.calculateEmi();
		this.setDefaultName();
	}

	renderComparison = ({ currentValue, modifiedValue, label, valueFormat = CommaSeparator, isBold = true }) => {
		const prependPesoSign = valueFormat === CommaSeparator; // Flag to determine peso sign addition

		if (currentValue === modifiedValue) {
			return (
				<BaseField
					customContainerClass="base-flex-container"
					customHeadingClass="black-heading loan_amount_heading"
					customValueClass={`bold loan_amount ${!isBold ? 'normal-font-weight' : ''}`}
					heading={label}
					value={
						prependPesoSign
							? `₱${valueFormat(currentValue || '0.00')}`
							: valueFormat(currentValue ?? 'None') || 'None'
					} // Add peso sign for CommaSeparator
				/>
			);
		} else {
			return (
				<>
					<BaseField
						customContainerClass="base-flex-container"
						customHeadingClass="black-heading loan_amount_heading"
						customValueClass={`bold loan_amount line-through ${!isBold ? 'normal-font-weight' : ''}`}
						heading={`From ${label}`}
						value={
							prependPesoSign
								? `₱${valueFormat(currentValue || '0.00')}`
								: valueFormat(currentValue ?? 'None') || 'None'
						} // Add peso sign for CommaSeparator
					/>
					<BaseField
						customContainerClass="base-flex-container"
						customHeadingClass="black-heading loan_amount_heading"
						customValueClass={`bold loan_amount ${!isBold ? 'normal-font-weight' : ''}`}
						heading={`To ${label}`}
						value={
							prependPesoSign
								? `₱${valueFormat(modifiedValue || '00.0')}`
								: valueFormat(modifiedValue ?? 'None') || 'None'
						} // Add peso sign for CommaSeparator
					/>
				</>
			);
		}
	};

	handleClick = ({ src }) => {
		if (src.includes('.pdf')) {
			// Create the modal div
			const modal = document.createElement('div');
			modal.id = 'modal';
			modal.style.zIndex = '1000';
			modal.style.position = 'fixed';
			modal.style.top = '0';
			modal.style.left = '0';
			modal.style.width = '100%';
			modal.style.height = '100%';
			modal.style.background = 'rgba(0,0,0,0.8)';
			modal.style.display = 'flex';
			modal.style.alignItems = 'center';
			modal.style.justifyContent = 'center';
			modal.style.cursor = 'pointer';
			modal.style.flexDirection = 'column';

			// Create the iframe element
			const modalIframe = document.createElement('iframe');
			modalIframe.src = src;
			modalIframe.style.width = '90%';
			modalIframe.style.height = '90%';
			modalIframe.style.border = 'none';

			// Append the iframe to the modal
			modal.appendChild(modalIframe);

			// create exit button
			const exitButton = document.createElement('button');
			exitButton.textContent = 'Exit';
			exitButton.style.background = '#fff';
			exitButton.style.padding = '5px 10px';
			exitButton.style.fontWeight = '40';
			exitButton.style.color = '#000';
			exitButton.style.border = 'none';
			exitButton.style.cursor = 'pointer';
			exitButton.style.fontSize = '16px';
			exitButton.style.zIndex = '1000';
			exitButton.style.borderRadius = '10%';
			exitButton.style.display = 'block';
			exitButton.style.marginTop = '10px';
			exitButton.style.marginLeft = 'auto';
			exitButton.style.marginRight = 'auto';
			// Append the button to the modal
			modal.appendChild(exitButton);

			// Append the modal to the body
			document.body.appendChild(modal);

			// Remove modal on click
			modal.addEventListener('click', function () {
				document.body.removeChild(modal);
			});
		} else {
			const modal = document.createElement('div');
			modal.id = 'modal';
			modal.style.zIndex = '1000';
			modal.style.position = 'fixed';
			modal.style.top = '0';
			modal.style.left = '0';
			modal.style.width = '100%';
			modal.style.height = '100%';
			modal.style.background = 'rgba(0,0,0,0.8)';
			modal.style.display = 'flex';
			modal.style.alignItems = 'center';
			modal.style.justifyContent = 'center';
			modal.style.cursor = 'pointer';
			modal.style.flexDirection = 'column';

			// Create the image element
			const modalImg = document.createElement('img');
			modalImg.src = src;
			modalImg.style.maxWidth = '90%';
			modalImg.style.maxHeight = '90%';

			modal.appendChild(modalImg);
			// create exit button
			const exitButton = document.createElement('button');
			exitButton.textContent = 'Exit';
			exitButton.style.background = '#fff';
			exitButton.style.padding = '5px 10px';
			exitButton.style.fontWeight = '40';
			exitButton.style.color = '#000';
			exitButton.style.border = 'none';
			exitButton.style.cursor = 'pointer';
			exitButton.style.fontSize = '16px';
			exitButton.style.zIndex = '1000';
			exitButton.style.borderRadius = '10%';
			exitButton.style.display = 'block';
			exitButton.style.marginTop = '10px';
			exitButton.style.marginLeft = 'auto';
			exitButton.style.marginRight = 'auto';
			// Append the button to the modal
			modal.appendChild(exitButton);

			// Append the modal to the body
			document.body.appendChild(modal);

			modal.addEventListener('click', function () {
				document.body.removeChild(modal);
			});
			// Remove modal on click
		}
	};

	customBodyRender = value => {
		if (!value || value === 'None') return 'No Image or PDF attached.';

		console.log({ value });

		return value.includes('.pdf') ? (
			<span
				style={{
					color: 'blue',
					cursor: 'pointer'
				}}
				onClick={this.handleClick.bind(this, {
					src: value
				})}>
				View PDF
			</span>
		) : (
			<span
				style={{
					color: 'blue',
					cursor: 'pointer'
				}}
				onClick={this.handleClick.bind(this, {
					src: value
				})}>
				View Image
			</span>
		);
	};

	render() {
		// NOSONAR

		const username = this.props.modifiedObject.name
			?.trim()
			.split(' ')
			.map((m, index) => m.charAt(0).toUpperCase() + m.slice(1))
			.join(' ');
		const { t } = this.props;
		const loanObject = this.props.modifiedObject;

		if (this.state._isDwollaPlaidScreenOpen) {
			return (
				<DwollaPlaid
					currentUser={this.props.currentUser}
					onBack={this.onBackDwollaPlaid}
					onClose={this.closeDwollaPlaid}
					openScreen={this.props.openScreen}
					setCurrentUser={this.props.setCurrentUser}
					supportedStates={this.props.supportedStates}
				/>
			);
		} else if (this.state._isPaymentMethodScreenOpen) {
			return (
				<PaymentMethod
					handleBack={this.closePaymentScreen}
					handleContinue={this.handlePaymentMethodCallback}
					maxPaymentDate={this.props.loanObject.first_installment_date}
				/>
			);
		} else {
			return (
				<section className="loan_details_review">
					<PageHeaderTitle
						className="p-x-16 m-y-b"
						title="Loan Details"
						onClick={this.props.closeSeeModification}
					/>
					<Grid container className="loan_details" id="reduce-width" justify="center">
						<Grid id="shadow-round" item sm={12} xs={12} justify="center">
							<Grid className="loan-list" sm={12} xs={12}>
								<Typography component="h3" variant="h5">
									<>
										<BaseField
											customContainerClass="base-flex-container"
											customHeadingClass="black-heading"
											customValueClass="bold loan_amount"
											heading={t('view_detail.loan_id')}
											value={this.props.modifiedObject.id}
										/>
										<BaseField
											customContainerClass="base-flex-container heading_name_container"
											customHeadingClass="black-heading"
											customValueClass="light-blue bold"
											heading={t(this.state._headingName)}
											value={<div className="loan_review_user_name">{username}</div>}
										/>
										<BaseField
											customContainerClass="base-flex-container"
											customHeadingClass="black-heading"
											heading={t('view_detail.guarantor')}
											value={
												this.props.modifiedObject.guarantor_exist ? (
													<div>
														<Link
															href="#"
															onClick={e => {
																e.preventDefault();
																this.props.onClickShowGuarator();
															}}
															style={{ fontSize: 'medium' }}
															variant="body2">
															{this.props.loanObject.guarantor_data.name}
														</Link>{' '}
													</div>
												) : (
													'None'
												)
											}
										/>
										{/* 
		const modifiedValue = this.state._modifiedLoan[target];
		const currentValue = this.props.modifiedObject[target]; */}

										<Divider variant="middle" className="mobile_divider fullw" />
										{this.renderComparison({
											currentValue: this.props.modifiedObject.principal,
											modifiedValue: this.props.modifiedObject.modified_loan?.principal,
											label: t('view_detail.loan_amount')
										})}

										{this.renderComparison({
											currentValue: this.props.modifiedObject.annual_rate,
											modifiedValue: this.props.modifiedObject.modified_loan?.annual_rate,
											label: t('view_detail.interest_rate'),
											valueFormat: value => `${value}%`
										})}
										{this.renderComparison({
											currentValue: this.props.modifiedObject.frequency,
											modifiedValue: this.props.modifiedObject.modified_loan?.frequency,
											label: t('view_detail.frequency'),
											valueFormat: value => t(`label.${convertToLangKey(value)}`),
											isBold: false
										})}
										{this.renderComparison({
											currentValue: this.props.modifiedObject.no_of_installments,
											modifiedValue: this.props.modifiedObject.modified_loan?.no_of_installments,
											label: t('view_detail.number_of_installments'),
											valueFormat: value => value
										})}
										{this.renderComparison({
											currentValue: this.props.modifiedObject.total_interest,
											modifiedValue: this.state._modifiedLoan.total_interest,
											label: t('view_detail.total_interest_to_be_paid')
										})}
										{this.renderComparison({
											currentValue: this.props.modifiedObject.amount_payable_per_installment,
											modifiedValue: this.state._modifiedLoan.amount_payable_per_installment,
											label: t('view_detail.amount_payable_per_installment')
										})}
										<Divider variant="middle" className="mobile_divider fullw" />
										{this.renderComparison({
											currentValue: this.props.modifiedObject.start_date,
											modifiedValue: this.props.modifiedObject.modified_loan?.start_date,
											label: t('view_detail.loan_start_date'),
											valueFormat: GetFormat
										})}
										{this.renderComparison({
											currentValue: this.props.modifiedObject.end_date,
											modifiedValue: this.state._modifiedLoan.end_date,
											label: t('view_detail.loan_end_date'),
											valueFormat: GetFormat
										})}

										<Divider variant="middle" className="mobile_divider fullw" />
										{this.renderComparison({
											currentValue: this.props.modifiedObject.first_installment_date,
											modifiedValue: this.state._modifiedLoan.first_installment_date,
											label: t('view_detail.first_payment_date'),
											valueFormat: GetFormat
										})}
										{this.renderComparison({
											currentValue: this.props.modifiedObject.amount_payable_per_installment,
											modifiedValue: this.state._modifiedLoan.amount_payable_per_installment,
											label: t('view_detail.next_payment_amount')
										})}
										<Divider variant="middle" className="mobile_divider fullw" />
										{this.renderComparison({
											currentValue: this.props.modifiedObject.reason,
											modifiedValue: this.props.modifiedObject.modified_loan?.reason,
											label: t('view_detail.loan_purpose'),
											valueFormat: value => value,
											isBold: false
										})}

										{this.renderComparison({
											currentValue: this.props.modifiedObject.collateral,
											modifiedValue: this.props.modifiedObject.modified_loan?.collateral,
											label: t('view_detail.collateral'),
											valueFormat: value => value,
											isBold: false
										})}

										{this.renderComparison({
											currentValue: this.props.modifiedObject.collateral_image || 'None',
											modifiedValue:
												this.props.modifiedObject.modified_loan?.collateral_image || 'None',
											label: 'Collateral Attachment',
											valueFormat: value => this.customBodyRender(value),
											isBold: false
										})}

										{this.renderComparison({
											currentValue: this.props.modifiedObject.lender_state,
											modifiedValue: this.props.modifiedObject.modified_loan?.lender_state,
											label: t('view_detail.lenders_state'),
											valueFormat: value =>
												this.props.hashedSupportedStates !== null
													? this.props.hashedSupportedStates[value]?.name || 'N/A' //
													: 'N/A',
											isBold: false
										})}

										<Divider variant="middle" className="mobile_divider fullw" />

										{this.renderComparison({
											currentValue: this.props.modifiedObject.additional_terms,
											modifiedValue: this.props.modifiedObject.modified_loan?.additional_terms,
											label: t('view_detail.additional_terms_conditions'),
											valueFormat: value => value,
											isBold: false
										})}
									</>
								</Typography>
							</Grid>
						</Grid>
					</Grid>
					<div style={{ paddingRight: '20px', paddingLeft: '20px' }}>
						{loanObject.last_modified_by !== this.props.currentUserId ? (
							<>
								<ButtonColumns>
									<Buttons
										action={this.handleAcceptModificationRequest}
										id="agree-button"
										name={t('buttons.accept_modification')}
									/>
								</ButtonColumns>
								<ButtonColumns>
									<Buttons
										id="cancel-button"
										action={this.rejectModification}
										name={t('buttons.reject_modification')}
									/>
								</ButtonColumns>
							</>
						) : null}

						<ButtonColumns>
							<Buttons
								id="amortization-btn"
								action={this.props.openAmortizationTable}
								name={t('buttons.view_amortization_table')}
							/>
						</ButtonColumns>
						<ButtonColumns>
							<Buttons id="back-btn" action={this.props.closeSeeModification} name={t('buttons.back')} />
						</ButtonColumns>
					</div>
					{this.state._isLoading ? <Loader /> : null}
				</section>
			);
		}
	}
}

export default withTranslation()(ViewModification);
